import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarFeminino from "../assets/images/pokemon.jpeg";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Pokemon() {
    useTrackPageView();
    useTimeOnPage();

    const handleWhatsappClick = async () => {

        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
            event: "leads",
            category: "whatsapp",
            action: "click",
            label: "geral_cta_main",
        });

        await trackEvent("whatsapp_click", {
            buttonLocation: "masculino_cta_main",
        });

        window.open("https://sendwich.pro/grupos/maeno-promos-tcg", "_blank");
    };

    // const handleWhatsappClick = async () => {
    //     await trackEvent("whatsapp_click", {
    //         buttonLocation: "pokemon_cta_main",
    //     });

    //     window.open("https://chat.whatsapp.com/GXZGmnXI3NBK4QyThqlkxN?s=cl&p=i&mlu=4", "_blank");
    // };

    return (
        <LandingCategory
            avatar={avatarFeminino}
            titleTop="ACHADINHOS"
            titleBottom="DE POKÉMON!"
            highlightWord="POKÉMON!"
            members="10.000"
            description="Entre no grupo VIP e receba todos os dias ofertas de cartas, boxes, ETBs, colecionáveis e muito mais com os melhores preços! ⚡"
            whatsappLink="https://sendwich.pro/grupos/maeno-promos-tcg"
            telegramLink="https://t.me/seu-link"
            theme={themes.masculino}
            onWhatsappClick={handleWhatsappClick}
        />
    );
}